'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const navLinks = [
  { href: '/', label: '首頁', en: 'Home' },
  { href: '/about', label: '關於我們', en: 'About' },
  { href: '/services', label: '業務範圍', en: 'Services' },
  { href: '/register', label: '報名中心', en: 'Register' },
  { href: '/contact', label: '聯繫我們', en: 'Contact' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header style={{ backgroundColor: '#FDFAF5', borderBottom: '1px solid rgba(201,168,76,0.25)' }} className="sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-3 flex-shrink-0">
            <img
              src="/assets/images/20b40342-cad4-461f-b81c-952050649b40-1773273486165.jpg"
              alt="香港貝語家居用品有限公司 Logo"
              className="h-14 w-14 object-contain"
            />
            <div className="hidden sm:block">
              <div style={{ color: '#2C2416', fontWeight: 800, fontSize: '0.9rem', lineHeight: 1.2 }}>
                香港貝語家居用品有限公司
              </div>
              <div style={{ color: '#C9A84C', fontWeight: 600, fontSize: '0.65rem', letterSpacing: '0.05em' }}>
                HONG KONG BEIYU HOUSEHOLD PRODUCTS
              </div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="px-4 py-2 rounded-lg text-sm font-600 transition-all duration-200"
                style={{
                  color: pathname === link?.href ? '#C9A84C' : '#5C4A1E',
                  backgroundColor: pathname === link?.href ? 'rgba(201,168,76,0.1)' : 'transparent',
                  fontWeight: pathname === link?.href ? 700 : 500,
                }}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Contact + Mobile Toggle */}
          <div className="flex items-center gap-3">
            <a
              href="mailto:hhess2071@gmail.com"
              className="hidden md:flex items-center gap-2 text-xs font-medium px-3 py-2 rounded-lg transition-all"
              style={{ color: '#C9A84C', border: '1px solid rgba(201,168,76,0.4)', backgroundColor: 'rgba(201,168,76,0.05)' }}
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              hhess2071@gmail.com
            </a>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="lg:hidden p-2 rounded-lg"
              style={{ color: '#5C4A1E' }}
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div style={{ borderTop: '1px solid rgba(201,168,76,0.2)', backgroundColor: '#FDFAF5' }} className="lg:hidden pb-4">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between px-4 py-3 text-sm font-medium transition-all"
                style={{
                  color: pathname === link?.href ? '#C9A84C' : '#5C4A1E',
                  backgroundColor: pathname === link?.href ? 'rgba(201,168,76,0.08)' : 'transparent',
                }}
              >
                <span>{link?.label}</span>
                <span style={{ color: '#C9A84C', fontSize: '0.7rem' }}>{link?.en}</span>
              </Link>
            ))}
            <div className="px-4 pt-3 mt-2" style={{ borderTop: '1px solid rgba(201,168,76,0.15)' }}>
              <a href="mailto:hhess2071@gmail.com" className="text-xs" style={{ color: '#C9A84C' }}>
                hhess2071@gmail.com
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
